<template>
  <div class="page flex-col">
    <div class="aboutdpp-header flex-col">
      <span class="aboutdpp-header_text1">{{ $portalText('aboutdpp', 't001') }}</span>
      <span class="aboutdpp-header_text2">{{ $portalText('aboutdpp', 't002') }}</span>
    </div>
    <div class="aboutdpp-group1 flex-col">
      <div class="anrchor_class" id="what"></div>
      <div class="aboutdpp-group1_title flex-row justify-between">
        <img class="group1_title-img" referrerpolicy="no-referrer"
          :src="decorationIcon" />
        <span class="group1_title-label">{{ $portalText('aboutdpp', 't003') }}</span>
      </div>
      <div class="aboutdpp-group1_box flex-col">
        <div class="group1_box-block1 flex-row justify-between">
          <img class="box-block1_img" referrerpolicy="no-referrer"
            :src="passportOneImg" />
          <div class="box-block1_div flex-col justify-between">
            <span class="block1_div-text">{{ $portalText('aboutdpp', 't004') }}</span>
            <div class="block1_div-wrapper">
              <span class="div-wrapper_span1">{{ $portalText('aboutdpp', 't005') }}</span>
              <span class="div-wrapper_span2">{{ $portalText('aboutdpp', 't006') }}</span>
              <span class="div-wrapper_span3">{{ $portalText('aboutdpp', 't007') }}</span>
              <span class="div-wrapper_span4">{{ $portalText('aboutdpp', 't008') }}</span>
              <span class="div-wrapper_span5">{{ $portalText('aboutdpp', 't009') }}</span>
            </div>
          </div>
        </div>
        <div class="group1_box-block2 flex-row justify-between">
          <div class="box-block2_wrapper flex-col justify-between">
            <span class="block2_wrapper-text1">{{ $portalText('aboutdpp', 't010') }}</span>
            <span
              class="block2_wrapper-text2">{{ $portalText('aboutdpp', 't011') }}</span>
          </div>
          <img class="image_4" referrerpolicy="no-referrer"
            :src="passportTwoImg" />
        </div>
      </div>
    </div>
    <div class="aboutdpp-group2 flex-col">
      <div class="anrchor_class" id="process"></div>
      <div class="aboutdpp-group2_title flex-row justify-between">
        <img class="group2_title-img" referrerpolicy="no-referrer"
             :src="decorationIcon" />
        <span class="group2_title-label">{{ $portalText('aboutdpp', 't012') }}</span>
      </div>
      <div class="group2_title-card flex-col">
        <img :src="imageProduct" />
      </div>
    </div>
    <div class="aboutdpp-group3 flex-col">
      <div class="anrchor_class" id="significance"></div>
      <div class="aboutdpp-group3_box1 flex-col"></div>
      <div class="aboutdpp-group3_box2 flex-col">
        <div class="group3_box2-block1 flex-col justify-between">
          <span class="box2-block1_text1">{{ $portalText('aboutdpp', 't013') }}</span>
          <span class="box2-block1_text2">{{ $portalText('aboutdpp', 't014') }}</span>
        </div>
        <div class="group3_box2-block2 flex-row justify-between">
          <div class="box2-block2_div1 flex-col justify-between">
            <div :class="['block2_div1-section flex-row', activeIndex == index ? 'active' : null]"
              v-for="(item, index) in cards" :key="index" @click="cardTabItem(index)">
              <div class="div1-section_paragraph flex-col justify-between">
                <span class="section_paragraph-text1">{{ item.cardItemTitle }}</span>
                <span class="section_paragraph-text2">
                  {{ item.cardItemLabels[0] }}
                  <br />
                  {{ item.cardItemLabels[1] }}
                </span>
              </div>
            </div>
          </div>
          <div class="box2-block2_div2 flex-col">
            <img :src="imageCardShow" />
          </div>
        </div>
      </div>
    </div>
    <footer-nav />
  </div>
</template>
<script>
import { portalData } from '@/portal/runtime';

import imageProduct from '@/assets/images/aboutdpp/image_product.png';
import imageCardOne from '@/assets/images/aboutdpp/image_card_one.png';
import imageCardTwo from '@/assets/images/aboutdpp/image_card_two.png';
import imageCardThree from '@/assets/images/aboutdpp/image_card_three.png';
import decorationIcon from '@/assets/images/home/decoration.png';
import passportOneImg from '@/assets/images/aboutdpp/passport_one.png';
import passportTwoImg from '@/assets/images/aboutdpp/passport_two.png';
export default {
  portalScope: 'aboutdpp',
  name: 'aboutdpp',
  metaInfo: {
    meta: [{
      name: 'keyWords',
      content: ''
    },
    {
      name: 'description',
      content: ''
    }],
  },
  data() {
    return portalData('aboutdpp', {
      decorationIcon,
      passportOneImg,
      passportTwoImg,
      imageProduct,
      activeIndex: 0,
      imageCardShow: imageCardOne,
      cards: [
        {
          cardItemTitle: '市场需求',
          cardItemLabels: [
            'DPP响应碳达峰碳中和需求',
            '为数字化绿色化协同发展打造新路径'
          ],
          cardItemImg: imageCardOne
        },
        {
          cardItemTitle: '行业趋势',
          cardItemLabels: [
            'DPP加速产业链数字化转型',
            'ESG数据深度整合成为趋势'
          ],
          cardItemImg: imageCardTwo
        },
        {
          cardItemTitle: '为全链路数字化运营赋能',
          cardItemLabels: [
            'DPP契合新兴信息技术演进',
            '为数字基础设施规模化应用构建新场景'
          ],
          cardItemImg: imageCardThree
        }
      ]
    })
  },
  methods: {
    cardTabItem(index) {
      this.activeIndex = index;
      this.imageCardShow = this.cards[index].cardItemImg;
    }
  },
}
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>